import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";
import { Stack } from "@mui/material";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import CheckboxField from "../../../../common/CheckboxField.tsx";
import SwitchMenuItem from "./SwitchMenuItem.tsx";

interface Props {
  field: ReportField;
  showExcludeZeroValues: boolean;
  onChanged: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

const SuppressBlankValues = ({ field, onChanged, showExcludeZeroValues, readonly }: Props) => {
  const hideBlankValue = Boolean(field.config.hideBlankValues);
  const hideZeroValues = Boolean(field.config.hideZeroValues);

  const handleChanged = (changes: Partial<FieldConfiguration>) => {
    const resetHideZeroValues = changes.hideBlankValues === false ? false : changes.hideZeroValues;
    onChanged({ ...changes, hideZeroValues: resetHideZeroValues }, false);
  };

  return (
    <Stack>
      <SwitchMenuItem
        caption="Suppress Blank Values"
        value={hideBlankValue}
        onClick={() => handleChanged({ hideBlankValues: !hideBlankValue })}
        disabled={readonly}
      />
      {showExcludeZeroValues && (
        <PopoverMenuItem sx={{ py: 0 }}>
          <CheckboxField
            label="Treat Zeros as Empty"
            checked={hideZeroValues}
            onChange={(value) => handleChanged({ hideZeroValues: value })}
            formControlLabelSx={{ ml: 1.25 }}
            disabled={readonly}
          />
        </PopoverMenuItem>
      )}
    </Stack>
  );
};

export default SuppressBlankValues;
